export default function CSVVEditSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - CSV Viewer &amp; Editor
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for CSV Viewer &amp;
            Editor.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I open a CSV file?
              </h3>
              <p className="mt-1">
                You can paste CSV data from the clipboard, open a file from your
                device, type or paste data manually, fetch CSV from a URL, or
                start with a blank document using the + button.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What file formats are supported?
              </h3>
              <p className="mt-1">
                CSV Viewer &amp; Editor supports CSV (comma-separated), TSV
                (tab-separated), semicolon-separated, and pipe-separated files.
                The delimiter is auto-detected when you open a file.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I edit CSV data?
              </h3>
              <p className="mt-1">
                Tap any cell to select it, then long-press to edit its value.
                You can add or delete rows and columns using the action bar at
                the bottom. Switch to the Edit tab for full raw text editing.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I compare two CSV files?
              </h3>
              <p className="mt-1">
                Use the Compare feature from the home screen. Paste or load CSV
                data into both panels and tap Compare. Differences are
                highlighted as added, removed, or changed.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I export CSV data?
              </h3>
              <p className="mt-1">
                From the viewer menu, you can save to device, export as PDF,
                export as Excel, print, convert to JSON/XML/TSV, or share the
                CSV directly. PDF and Excel exports may require watching a short
                ad or purchasing ad-free.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I sort and filter data?
              </h3>
              <p className="mt-1">
                Tap any column header to sort by that column. Tap the filter icon
                to apply column-level filters. You can also use the search bar
                to find specific values across all cells.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why does the app show ads?
              </h3>
              <p className="mt-1">
                Ads help support continued development. You can remove all ads
                with a one-time in-app purchase from Settings.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I change the language?
              </h3>
              <p className="mt-1">
                Go to Settings and tap Language. CSV Viewer &amp; Editor
                supports 15 languages including English, Hindi, Spanish,
                Portuguese, Arabic, Chinese, Japanese, Korean, and more.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            For help, bug reports, or privacy-related questions, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We usually respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            If something is not working as expected, include these details in
            your email:
          </p>
          <ul className="list-disc space-y-1 pl-6">
            <li>Your device model and OS version</li>
            <li>Your app version (found in Settings)</li>
            <li>What you were trying to do</li>
            <li>The error or unexpected result</li>
            <li>Steps to reproduce the issue, if known</li>
            <li>A sample CSV file if relevant</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Important Links</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              Privacy Policy:{" "}
              <a
                href="/apps/csvvedit/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/csvvedit/privacy-policy
              </a>
            </li>
            <li>
              Support:{" "}
              <a
                href="/apps/csvvedit/support"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/csvvedit/support
              </a>
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              <strong>App Name:</strong> CSV Viewer &amp; Editor
            </li>
            <li>
              <strong>Package:</strong> com.cosmovex.csvvedit
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-sm text-[#8A93A2]">
          &copy; 2026 Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
